import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdLibraryDeleteCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/media_library_data",
  "/engagement/media_library_data",
  "/engagement/:app_group_id/media_library_asset_data/:asset_id",
];
